import dealerApiClient from '../api/dealerApiClient'
import type { DealerOrderDetail, DealerOrderItem, DealerOrdersPage, DealerOrdersQuery } from '../types'

export async function getOrders(query: DealerOrdersQuery): Promise<DealerOrdersPage> {
  // пустые параметры не отправляем, чтобы бэк применил свои значения по умолчанию
  const params: Record<string, unknown> = Object.fromEntries(
    Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== '')
  )
  // from/to (включительно) бэк трактует в часовом поясе браузера
  if (params.from || params.to) params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const { data } = await dealerApiClient.get<DealerOrdersPage>('/orders', { params })
  return data
}

export async function getOrder(id: string): Promise<DealerOrderDetail> {
  const { data } = await dealerApiClient.get<DealerOrderDetail>(`/orders/${id}`)
  return data
}

// фиксация копирования ссылки/телефона: fire-and-forget, ошибка не должна мешать работе
export function trackOrderEvent(id: string, type: 'LINK_COPIED' | 'PHONE_COPIED'): void {
  dealerApiClient.post(`/orders/${id}/events`, { type }).catch((err) => {
    console.error(`[ERROR] Failed to track order event — id: ${id}, type: ${type}`, err)
  })
}

// 409 REPORT_NOT_READY — отчёт ещё не готов
export async function markOrderSent(id: string): Promise<DealerOrderItem> {
  const { data } = await dealerApiClient.post<DealerOrderItem>(`/orders/${id}/sent`)
  console.log(`[INFO] Order marked as sent — id: ${id}`)
  return data
}

// 409 REPORT_NOT_READY — отчёт не готов
export async function unmarkOrderSent(id: string): Promise<DealerOrderItem> {
  const { data } = await dealerApiClient.delete<DealerOrderItem>(`/orders/${id}/sent`)
  console.log(`[INFO] Order unmarked as sent — id: ${id}`)
  return data
}

// ДЦ вписывает или исправляет номер клиента; пустая строка удаляет номер (400 PHONE_INVALID)
export async function updateOrderClientPhone(id: string, phone: string): Promise<DealerOrderItem> {
  const { data } = await dealerApiClient.put<DealerOrderItem>(`/orders/${id}/client-phone`, { phone: phone.trim() || null })
  console.log(`[INFO] Order client phone updated — id: ${id}`)
  return data
}
